import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Layout } from "../components/Layout";
import { BiniBubble } from "../components/Bini";
import { t } from "../i18n";

// Light formatting: "## " headings, "- " list items, blank line = new paragraph
export const RichText = ({ text }) => (
  <div className="space-y-4 text-base sm:text-lg leading-relaxed">
    {text.split(/\n\s*\n/).map((block, i) => {
      const lines = block.split("\n").filter(Boolean);
      return (
        <div key={i} className="space-y-1">
          {lines.map((l, j) => l.startsWith("## ")
            ? <h2 key={j} className="pt-2 text-xl sm:text-2xl font-extrabold">{l.slice(3)}</h2>
            : l.startsWith("- ")
              ? <p key={j} className="pl-5 relative before:content-['•'] before:absolute before:left-0 before:text-[#38B6FF]">{l.slice(2)}</p>
              : <p key={j}>{l}</p>)}
        </div>
      );
    })}
  </div>
);

export default function Legal({ slug }) {
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { setPage(null); api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setMissing(true)); }, [slug]);

  return (
    <Layout back="/">
      {missing && <BiniBubble testId="legal-missing">{t("soon.notFound")}</BiniBubble>}
      {page && (
        <article className="cloud-card p-6 sm:p-10" data-testid={`legal-page-${slug}`}>
          <h1 className="text-3xl sm:text-4xl font-extrabold" data-testid="legal-title">{page.title}</h1>
          <p className="mt-1 text-sm opacity-60">{t("legal.updated", { date: new Date(page.updated_at).toLocaleDateString("fr-FR") })}</p>
          <div className="mt-6"><RichText text={page.content} /></div>
        </article>
      )}
    </Layout>
  );
}
